<div *ngIf="SHOW_PANEL">
	<div
		*ngFor="let skeleton of panelSkeletonList"
		class="container m-t-1 p-1"
		[ngClass]="cssClassesList"
	>
		<div
			*ngFor="let row of panelRowsList; let i = index"
			[ngClass]="{ 'my-0-5': i % 2 == 1 }"
			class="col-content-height"
			fxLayout="row"
			fxLayoutGap="2rem"
		>
			<div
				*ngFor="let column of panelColumnsList; let i = index"
				class="skelton-loader"
				fxFlex
			></div>
		</div>
	</div>
</div>

<div *ngIf="SHOW_CHIPS">
	<div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="0.5rem">
		<div *ngFor="let skeleton of chipsList" class="chip-height skelton-loader"></div>
	</div>
</div>

<div *ngIf="SHOW_CURRENT_RATES" class="h-100 background-white p-1 br-4">
	<div class="skelton-loader"></div>

	<div class="my-0-5" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>

	<div class="m-t-1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>

	<div class="m-t-1" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>

	<div fxLayoutAlign="start end">
		<div class="m-t-2 skelton-loader"></div>
	</div>
</div>

<div *ngIf="SHOW_RECENT_TRANSACTIONS" class="h-100 background-white p-1 br-4">
	<div class="my-0-5" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="3rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>
	<div class="my-0-5" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>
	<div class="my-0-5" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>
	<div class="my-0-5" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>
	<div class="my-0-5" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="3rem">
		<div class="skelton-loader" fxFlex></div>
		<div class="skelton-loader" fxFlex></div>
	</div>
</div>

<div *ngIf="SHOW_DASHBOARD_HOT_LANES">
	<div class="m-t-1 skelton-loader"></div>
	<div class="m-t-1 skelton-loader"></div>
	<div class="m-t-1 skelton-loader"></div>
	<div class="m-t-1 skelton-loader"></div>
</div>

<div *ngIf="SHOW_SINGLE_LOADER">
	<div class="skelton-loader"></div>
</div>
